export default "__VITE_ASSET__bb6cda29__"